<template>
  <div>
    <div class="slide-carousel slides-listing listing-rowed mt-lg-3 mb-lg-3" v-if="sliders">
      <VueAgile
        :options="options"
        ref="carousel"
      >
        <div
          v-for="(slide, index) in sliders"
          :key="index"
          :class="`slide--${index}`"
          class="slide"
        >
          <SlideCard
            :slide="slide"
          />
        </div>
        <template slot="prevButton"><i class="fa fa-angle-left"></i></template>
        <template slot="nextButton"><i class="fa fa-angle-right"></i></template>
      </VueAgile>
    </div>
  </div>
</template>

<script>

import SlideCard from '@/components/common/Carousel/SlideCard.vue'
import { VueAgile } from 'vue-agile'

export default {
  name: 'Carousel',
  props: ['sliders'],
  components: {
    SlideCard,
    VueAgile
  },
  data () {
    return {
      options: {
        dots: false,
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              dots: this.sliders.length > 1
            }
          }
        ],
        navButtons: this.sliders.length > 1
      }
    }
  }
}
</script>

<style lang="scss">
/* POSTS THUMB CAROUSEL */
.slide-carousel {
  .agile__nav-button {
    position: absolute;
    top: calc(50% - 15px);
    background: transparent;
    padding: 0;
    border: none;

    @include tablet {
      top: calc(50% - 30px);
    }

    i {
      color: $color2;
      font-size: 30px;

      @include tablet {
        font-size: 50px;
      }
    }
  }

  .agile__nav-button--prev {
    left: -10px;

    @include tablet {
      left: -25px;
    }
  }

  .agile__nav-button--next {
    right: -10px;

    @include tablet {
      right: -25px;
    }
  }

  .agile__slide {
    padding: 10px;
  }

  .agile__dots{
    margin: 10px auto;

    @include tablet {
      position: absolute;
      top: -36px;
      right: 0;
      margin-bottom: 0;
    }

    .agile__dot{
      margin: 0 10px;
      button{
        background-color: #ddd;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: block;
        height: 10px;
        font-size: 0;
        line-height: 0;
        margin: 0;
        padding: 0;
        transition-duration: .3s;
        width: 10px;
      }

      &--current,&:hover{
        button{
          background-color: $color2;
        }
      }
    }
  }
}
</style>
